<template>
  <k-editor-form v-if="clip_export">
    <template v-slot:left>
      <h3 style="margin-bottom: 15px;">Export MTV compilation</h3>
      <k-autocomplete
        v-bind:items="mp4_list"
        v-model="clip_export.meta.clip.key"
        label="Video"
        item-text="name"
        item-value="key">
      </k-autocomplete>
      <k-autocomplete
        v-bind:items="png_list"
        v-model="clip_export.meta.clip.poster_key"
        label="Poster"
        item-text="name"
        item-value="key">
      </k-autocomplete>
      <component v-for="elem in form.left" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="clip_export.form_data">
        <k-flex :cols="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
          <component v-bind:is="celem.type" v-bind="celem" v-model="clip_export.form_data"></component>
        </k-flex>
      </component>
    </template>
    <template v-slot:right>
      <component v-for="elem in form.right" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="clip_export.form_data">
        <k-flex :cols="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
          <component v-bind:is="celem.type" v-bind="celem" v-model="clip_export.form_data"></component>
        </k-flex>
      </component>
    </template>
    <template v-slot:right-buttons>
      <k-btn color="success" @click="export_clip">Export</k-btn>
	    <k-btn flat @click="$emit('close')">Close</k-btn>
    </template>
  </k-editor-form>
</template>

<script>
import * as FormItems from '@/components/form_items'

import SettingsModel from '@/models/settings.js'
import ClipModel from '@/models/clip.js'
import EventModel from '@/models/event.js'
import moment from 'moment'
import Vue from 'vue';

export default {
  props: ['event_uuid'],
  components: {
    ...FormItems
  },
  data() {
    var ch = this.$cloudserver.channel("events:clip_export:create");
    return {
      ws_channel: ch,
      clip_export: undefined,
      mp4_list: [],
      png_list: []
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.convertClipExport(newVal, oldVal);
        }
      },
      deep: true
    },
    content_list(newVal) {
      if(_.isEmpty(newVal)) return;
      this.update_items();
    }
  },
  computed: {
    content_list () {
      var list = _.find(Object.values(this.$store.state.cms_lists), (list) => {
        return _.get(list, "meta.system") == true && _.get(list, "meta.system_type") == "cloudrec-import"
      });
      return list.id;
    },
    form () {
      return (this.settings_value.form||{}).fields || [];
    },
    settings () {
      return SettingsModel.get_by_name("mtv_special_export");
    },
    settings_value() {
      return (this.settings||{}).value || {}
    },
    default_value_functions() {
      var self = this;
      return {
        event_start_plus_clip_start (event, clip, info) {
          return event.cached_start_time;
        },
        event_start_plus_clip_end (event, clip, info) {
          return event.cached_start_time;
        },
        from_event(event, clip, info) {
          return _.get(event, info.key, info.default_value);
        }
      }
    }
  },
  methods: {
    update_items() {
      Vue.http.get("content_list/"+this.content_list).then((response) => {
        this.mp4_list = [];
        this.png_list = [];

        _.each(response.body, (item) => {
          if(item.type == "import-mp4") {
            this.mp4_list.push(
              {
                key: item.key,
                name: item.key.substr(item.key.lastIndexOf("/") + 1),
                created_at: item.created_at
              }
            )
          }

          if(item.type == "import-png") {
            this.png_list.push(
              {
                key: item.key,
                name: item.key.substr(item.key.lastIndexOf("/") + 1),
                created_at: item.created_at
              }
            )
          }
        })

        // Sort lists reverse alphabetically by name. This causes more recent files to be first
        // from filename timestamps.
				if(this.mp4_list.length > 0) {
					this.mp4_list.sort((item1, item2) => {
						if(item1.created_at > item2.created_at) return -1
						if(item1.created_at < item2.created_at) return 1
						return 0
					})
				}

				if(this.png_list.length > 0) {
					this.png_list.sort((item1, item2) => {
						if(item1.created_at > item2.created_at) return -1
						if(item1.created_at < item2.created_at) return 1
						return 0
					})
				}
      }, (response) => {

      });
    },

    export_clip() {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var clip_export = _.cloneDeep(this.clip_export);
        delete clip_export.form_data.__event__;

        var export_configuration_ids = _.get(this.settings, "value.export_configuration_id");

        var save = (export_configuration_id) => {
          return new Promise((resolve, reject) => {
            clip_export.clip_uuids = [];
            clip_export.meta.export_configuration_id = _.get(export_configuration_id, "id", export_configuration_id);
            clip_export.meta.destination = this.settings.name;
            clip_export.event_uuid = this.event_uuid

            clip_export.meta.title = "MTV compilation import";
            if(_.has(export_configuration_id, "name")) {
              clip_export.meta.title += " (" + _.get(export_configuration_id, "name", "") + ")";
            }

            clip_export.meta.mtv_special = true;

            this.ws_channel.save({clip_export: clip_export}, false)
              .then((msg) => {
                resolve(export_configuration_id)
              })
              .catch((msg) => {
                console.log("Unable to export special", msg);

                reject(export_configuration_id)
              });
          });
        }

        if(_.isArray(export_configuration_ids)) {
          Promise.allSettled(_.map(export_configuration_ids, save)).then((results) => {
            _.each(results, (result) => {
              if(result.status == "fulfilled") {
                self.$message.success("Exporting clip ("+_.get(result, "value.name", "")+")!");
              } else {
                self.$message.warning("Unable to export clip ("+_.get(result, "reason.name", "")+")!");
              }
            });

            self.$emit("input", false);
          })
        } else if(_.isNumber(export_configuration_ids)) {
          save(export_configuration_ids).then(() => {
            self.$message.success("Exporting clip!");

            self.$emit("input", false);
            self.$emit("exported")
          }).catch((result) => {
            console.log("Unable to export MTV special", result)
            self.$message.warning("Unable to export clip!");

            self.$emit("input", false);
          });
        }
      }
    },

    get_event(cb) {
      var channel = this.$cloudserver.channel("events:"+this.event_uuid, false);
      var on_init_ref;
      on_init_ref = channel.on("data", function(msg) {
        channel.off("data", on_init_ref);
        channel.leave();
        cb(msg.data);
      });
      channel.join();
      if(!_.isEmpty(channel.data)) {
        channel.off("data", on_init_ref);
        channel.leave();
        cb(channel.data);
      }
    },
    convertClipExport (newVal, oldVal) {
			var clip_export = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(clip_export) == "undefined" || _.isEmpty(clip_export)) return;

      var form_data = {};
      this.get_event((event) => {
        _.each([].concat(this.form.left,this.form.right), (field) => {
          if(typeof(field.default_value) == "object" && field.default_value.type == "function" && typeof(this.default_value_functions[field.default_value.function]) == "function") {
            form_data[field.name] = this.default_value_functions[field.default_value.function](event, undefined, field.default_value);
          } else if(field.default_value) {
            form_data[field.name] = field.default_value;
          } else {
            if(field.type == "date-time") {
              form_data[field.name] = moment().unix();
            } else if(field.type == "check-box") {
              form_data[field.name] = false;
            } else {
              form_data[field.name] = null;
            }
          }
        });
        form_data.__event__ = event;
        clip_export.form_data = form_data;
        clip_export.meta.clip = {key: "", poster_key: ""}
        // Exposed only after form_data is complete so it is reactive.
        this.clip_export = clip_export;
      });
		},
    row_classes(childs) {
      return Math.round(12/childs.length);
    }
  },
  created() {
    this.ws_channel.join();
    // Channel data is already cached on reopen, so no new data event fires.
    this.convertClipExport(this.ws_channel.data);
  },
  mounted() {
    this.update_items();
  }
}
</script>
